/**
 * Braze Lead Capture Send (E20-1185)
 *
 * Listens for the shared `lead_capture:submit` event dispatched by
 * assets/bfx-waitlist-form.js — fired by both the PDP "Join the Waitlist"
 * modal (E20-1123) and the Lead Capture section (E20-1184) — and forwards the
 * lead to Braze via the Web SDK app embed block (config/settings_data.json,
 * global `window.braze` object).
 *
 * Uses the email as the Braze external_id: `changeUser` resolves to the same
 * profile on repeat submissions instead of creating a new anonymous one each
 * time. SDK readiness is handled by the shared util.braze helper.
 *
 * Reports the outcome back to the originating <waitlist-form> via a bubbling
 * `lead_capture:result` event ({ success }), so the form can show its real
 * success/error state instead of assuming success on submit (E20-1472).
 */

import { logCustomEventOrThrow, sendToBraze } from 'util.braze';

const sendLeadCaptureEvent = ({ email, sku, market, source }) =>
  sendToBraze(
    () => {
      window.braze.changeUser(email);
      logCustomEventOrThrow('lead_capture', { sku, market, source });
    },
    'bfx-braze-lead-capture: lead_capture',
    'bfx-braze-lead-capture'
  );

document.addEventListener('lead_capture:submit', async (event) => {
  const lead = event.detail;
  // Captured before the await, deliberately: `event.target` is only reliable while the
  // dispatch is on the stack, so reading it after the send would return the wrong form —
  // or null — whenever a page carries more than one waitlist form. Don't inline this back
  // into the dispatch call below.
  const form = event.target;
  const success = await sendLeadCaptureEvent(lead);

  form.dispatchEvent(
    new CustomEvent('lead_capture:result', { bubbles: true, detail: { success } })
  );
});
